export const DEVICE_TYPE_TERMINAL = 'handset'
export const DEVICE_TYPE_AGILE_TV = 'set_top_box'
export const DEVICE_TYPE_WITHOUT_IMEI = 'other-devices'
